import { NgModule } from '@angular/core';

import { AlphaNumericSortPipe } from './pipes/alpha-numeric-sort.pipe';
import { DistanceToNowStrictPipe } from './pipes/date-time.pipe';
import { FormatTimePipe } from './pipes/format-time-pipe.pipe';
import { StorageUnitPipe } from './pipes/storage-unit-pipe.pipe';
import { TrustHtmlPipe, TrustUrlPipe } from './pipes/trust.pipe';
import { InterpolatePipe, TranslatePipe } from '../translation.service';

const pipes = [
  AlphaNumericSortPipe,
  DistanceToNowStrictPipe,
  FormatTimePipe,
  InterpolatePipe,
  StorageUnitPipe,
  TranslatePipe,
  TrustHtmlPipe,
  TrustUrlPipe,
];

@NgModule({
  declarations: pipes,
  exports: pipes,
})
export class PipesModule { }
